// =====================================================================
// WeddingOS – Guest Session
// =====================================================================
// localStorage statt sessionStorage:
// → Session überlebt Seiten-Reload und Tab-Schließen
// → Gast muss QR nur einmal scannen, auch wenn Browser-Tab neu öffnet
//
// Session-Shape:
// {
//   tableToken,    // für Skip-Check in Join.jsx
//   guest_id,
//   guest_name,
//   table_number,
//   table_label,   // optionale Tisch-Bezeichnung, z.B. "Familie Müller"
//   wedding_id,
//   wedding_name,
//   event_date,
//   location,
// }
// =====================================================================

const KEY = "wos_guest_session";

export function saveGuestSession(session) {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function loadGuestSession() {
  const raw = localStorage.getItem(KEY);
  return raw ? JSON.parse(raw) : null;
}

export function clearGuestSession() {
  localStorage.removeItem(KEY);
}

// Tisch-Anzeige: "Tisch 1 – Familie Müller" bzw. nur "Tisch 1" ohne Bezeichnung
export function tableDisplay(number, label) {
  if (!number) return "";
  const base = `Tisch ${number}`;
  return label ? `${base} – ${label}` : base;
}

// Begrüßungsname: Spitzname wenn vorhanden, sonst Vorname (erstes Wort)
export function greetName(name = "", nickname = "") {
  const nick = (nickname || "").trim();
  if (nick) return nick;
  return (name || "").trim().split(/\s+/)[0] || (name || "");
}
